export default __webpack_public_path__ + "static/nina_busca-43226f146669bc9f3928834521bcb857.png";